import { useQuery, keepPreviousData } from '@tanstack/react-query'
import { contactSearchApi } from '../lib/api'
import type { ContactSearchRequest } from '../types/contact'

export function useContactSearch(params: ContactSearchRequest, enabled = true) {
  return useQuery({
    queryKey: ['contacts', 'search', params],
    queryFn: async () => {
      const response = await contactSearchApi.search(params)
      return response.data
    },
    enabled,
    placeholderData: keepPreviousData, // Keep previous data while fetching new data
    staleTime: 30 * 1000, // 30 seconds for search results
  })
}

export function useContactSearchOptions() {
  return useQuery({
    queryKey: ['contacts', 'search', 'options'],
    queryFn: async () => {
      const response = await contactSearchApi.getOptions()
      return response.data
    },
    staleTime: 10 * 60 * 1000, // 10 minutes for dropdown options
  })
}

export function useContact(id: string | undefined) {
  return useQuery({
    queryKey: ['contacts', id],
    queryFn: async () => {
      if (!id) throw new Error('Contact ID is required')
      const response = await contactSearchApi.getById(id)
      return response.data
    },
    enabled: !!id,
  })
}
